import useStartNewHpDeviceVersion, {
    IUseStartNewHpDeviceVersionOutput,
} from "./useStartNewHpDeviceVersion"
import { LCTOnlyDatasets } from "../../../../../constants/enums"

/**
 * Thin wrapper around useStartNewHpDeviceVersion — the only difference is
 * the dataset passed to the API (ACU vs HP). All form data, types, and mappers
 * are shared.
 */
const useStartNewAcuDeviceVersion = (
    deviceRef: string,
    attachmentUUID: string
): IUseStartNewHpDeviceVersionOutput =>
    useStartNewHpDeviceVersion(deviceRef, attachmentUUID, LCTOnlyDatasets.ACU)

export default useStartNewAcuDeviceVersion
